<div class="login-top-bar">
  <div class="login-logo">
    <img src="../../assets/img/Logo_bianco.png" alt="Logo" />
  </div>
  <div class="background-logo">
    <img src="../../assets/img/sfondo_frecce.png" alt="Background-logo" class="mt-4" />
  </div>
</div>
<div class="login-container">
  <h2 class="login-title">{{ 'REGISTER.TITLE' | translate }}</h2>
  <p class="confirmation-message">
    {{ 'REGISTER.MESSAGE' | translate }}
  </p>
  <form class="form-container" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="custom-hr"></div>
    <div class="form-section profile-section">
      <div class="d-flex align-items-center form-title" [ngClass]="isLight ? 'light' : 'dark'">
        <div class="d-flex align-items-center p-2">
          <img class="section-image" src="../../assets/icon/picture.svg" alt="picture" />
        </div>
        <div class="form-title-text-container">
          <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
            {{ 'PERSONAL_INFO_FORM.IMAGE_PROFILE' | translate }}
          </p>
        </div>
      </div>
      <div class="user-image-container">
        @if (userImage) {
          <img [src]="userImage" class="user-image" alt="Profile image" />
        }
      </div>
      <div class="upload-container" (click)="fileInput.click()" (keydown.enter)="fileInput.click()" tabindex="0">
        <p class="upload-instruction">Carica Immagine</p>
        <div class="line"></div>
        <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none" formControlName="img" />
      </div>
    </div>

    <div class="form-section personal-info-section">
      <div class="d-flex align-items-center form-title" [ngClass]="isLight ? 'light' : 'dark'">
        <div class="d-flex align-items-center p-2">
          <img class="section-image" src="../../assets/icon/user.svg" alt="user" />
        </div>
        <div class="form-title-text-container">
          <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
            {{ 'PERSONAL_INFO_FORM.PERSONAL_INFORMATION' | translate }}
          </p>
        </div>
      </div>
      <div class="input-wrapper">
        <label for="name"> {{ 'PERSONAL_INFO_FORM.NAME' | translate }}*</label>
        <app-icam-input
          label="{{ 'PERSONAL_INFO_FORM.NAME' | translate }}"
          inputId="name"
          [isSlim]="true"
          formControlName="firstName"
          [required]="true"
        />
      </div>
      <div class="input-wrapper">
        <label for="last_name">{{ 'PERSONAL_INFO_FORM.LAST_NAME' | translate }}*</label>
        <app-icam-input
          label="{{ 'PERSONAL_INFO_FORM.LAST_NAME' | translate }}"
          inputId="last_name"
          [isSlim]="true"
          formControlName="lastName"
          [required]="true"
        />
      </div>
      <div class="input-wrapper">
        <label for="role">{{ 'PERSONAL_INFO_FORM.ROLE' | translate }}</label>
        <app-icam-input
          label="{{ 'PERSONAL_INFO_FORM.ROLE' | translate }}"
          inputId="role"
          [isSlim]="true"
          [required]="false"
          formControlName="role"
        />
      </div>
      <div class="input-wrapper">
        <label for="phone">{{ 'PERSONAL_INFO_FORM.PHONE' | translate }}</label>
        <app-icam-input
          label="{{ 'PERSONAL_INFO_FORM.PHONE' | translate }}"
          inputId="phone"
          formControlName="phone"
          [isSlim]="true"
          inputType="tel"
          [required]="false"
        />
      </div>
      <div class="input-wrapper">
        <p class="required-info">*{{ 'PERSONAL_INFO_FORM.REQUIRED' | translate }}</p>
      </div>
    </div>

    <div class="form-section access-info-section">
      <div class="d-flex align-items-center form-title" [ngClass]="isLight ? 'light' : 'dark'">
        <div class="d-flex align-items-center p-2">
          <img class="section-image" src="../../assets/icon/key.svg" alt="key" />
        </div>
        <div class="form-title-text-container">
          <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
            {{ 'PERSONAL_INFO_FORM.ACCESS_INFORMATION' | translate }}
          </p>
        </div>
      </div>
      <div class="input-wrapper">
        <label for="email">Email*</label>
        <app-icam-input
          label="Email"
          inputId="email"
          formControlName="email"
          [isSlim]="true"
          inputType="email"
          [required]="true"
        />
      </div>
      <div class="input-wrapper">
        <label for="password">Password*</label>
        <app-icam-input
          label="Password"
          inputId="password"
          formControlName="password"
          [isSlim]="true"
          inputType="password"
          [required]="true"
        />
      </div>
      <div class="input-wrapper">
        <label for="confirm-password">{{ 'PERSONAL_INFO_FORM.CONFIRM_PASSWORD' | translate }}*</label>
        <app-icam-input
          label="{{ 'PERSONAL_INFO_FORM.CONFIRM_PASSWORD' | translate }}"
          formControlName="confirm_password"
          inputId="confirm_password"
          [isSlim]="true"
          inputType="password"
          [required]="true"
        />
      </div>
      <div class="checkbox-container">
        <input type="checkbox" id="infoCheckbox" required formControlName="privacy" />
        <label id="infoChecrkboxLabel" class="text-muted" for="infoCheckbox">
          {{ 'PERSONAL_INFO_FORM.PRIVACY_PREFIX' | translate }}
          <span
            class="text-link"
            (click)="onOpenModalInfo($event)"
            (keydown.enter)="onOpenModalInfo($event)"
            tabindex="0"
          >
            {{ 'PERSONAL_INFO_FORM.PRIVACY_LINK' | translate }}
          </span>
          {{ 'PERSONAL_INFO_FORM.PRIVACY_SUFFIX' | translate }}
        </label>
      </div>
      <button type="submit" class="button-form-submit mt-4" [disabled]="!form.valid" [class.disabled]="!form.valid">
        {{ 'PERSONAL_INFO_FORM.REGISTER_ME' | translate }}
      </button>
    </div>
  </form>

  <div class="mt-5">
    <div class="login-footer justify-content-center">
      <div class="pb-3" id="icamRights">
        <span> &copy; {{ getYear() }} ICAM S.P.A - All rights reserved </span>
      </div>
    </div>
  </div>
</div>
